<template>
  {{displayStatusFilterAsText}}
  <div class="float-right" v-if="groupStore.collection.length > 0">

    <PopoverGroup class="hidden sm:flex sm:items-baseline sm:space-x-8">
      <Popover as="div" id="desktop-menu" class="relative z-10 inline-block text-left">
        <div>
          <PopoverButton class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900">

            <span v-if="filterBy === 'groups'">{{ $t('flow.groups') }}</span>
            <span v-else>{{ $t('flow.agents') }}</span>

            <span v-if="filterBy === 'groups' && selectedGroupsCount" class="ml-1.5 rounded py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums">{{selectedGroupsCount}}</span>
            <span v-if="filterBy === 'agents' && selectedAgentsCount" class="ml-1.5 rounded py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums">{{selectedAgentsCount}}</span>
            <ChevronDownIcon class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
          </PopoverButton>
        </div>
        <PopoverPanel class="origin-top-right absolute rounded-md right-0 mt-2 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div class="bg-white rounded-md shadow-2xl p-4">
            <form class="space-y-4 w-56">
              <div class="">
                <input id="filter-by-group"  name="filterBy" v-model="filterBy" value="groups" type="radio" class="opacity-0 h-0 w-0 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                <label for="filter-by-group" class="text-sm font-medium text-gray-900 whitespace-nowrap cursor-pointer block flex">
                  <input v-if="filterBy === 'groups'" :checked="allGroupsSelected" @click="toggleAllGroups" id="group-filter-mobile-all" type="checkbox" class="mt-1 mr-3 h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <span>{{ $t('flow.groups') }}</span>
                  <ChevronDownIcon v-if="filterBy !== 'groups'" class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                </label>
              </div>
              <div v-if="filterBy === 'groups'" class="space-y-2">
                <div v-for="group in groupStore.collection" :key="group.id" class="flex items-center">
                  <input :id="`filter-mobile-${group.id}`"  :name="`group[]`" v-model="selectedGroups" :value="group.id" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <label :for="`filter-mobile-${group.id}`" class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap">
                    {{ group.attributes.name }}
                  </label>
                </div>
                <div class="flex items-center">
                  <input :id="`filter-mobile-null`"  :name="`group[]`" v-model="selectedGroups" :value="null" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <label :for="`filter-mobile-null`" class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap">
                    {{ $t('flow.notAssigned') }}
                  </label>
                </div>
              </div>
              <div>
                <input id="filter-by-agents"  name="filterBy" v-model="filterBy" value="agents" type="radio" class="opacity-0 h-0 w-0  border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                <label for="filter-by-agents" class="text-sm font-medium text-gray-900 whitespace-nowrap cursor-pointer block flex" style="margin-top: -15px">
                  <input v-if="filterBy === 'agents'" :checked="allAgentsSelected" @click="toggleAllAgents" id="agent-filter-mobile-all" type="checkbox" class="mt-1 mr-3 h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <span>{{ $t('flow.agents') }}</span>
                  <ChevronDownIcon v-if="filterBy !== 'agents'" class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                </label>
              </div>
              <div v-if="filterBy === 'agents'" class="space-y-2">
                <div v-for="agent in agentStore.collection" :key="agent.id" class="flex items-center">
                  <input :id="`agent-filter-mobile-${agent.id}`"  :name="`agent[]`" v-model="selectedAgents" :value="agent.id" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <label :for="`agent-filter-mobile-${agent.id}`" class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap">
                    {{ agent.attributes.name }}
                  </label>
                </div>
                <div class="flex items-center">
                  <input :id="`agent-filter-mobile-null`"  :name="`agent[]`" v-model="selectedAgents" :value="null" type="checkbox" class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500" />
                  <label :for="`agent-filter-mobile-null`" class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap">
                    {{ $t('flow.notAssigned') }}
                  </label>
                </div>
              </div>
            </form>
          </div>
        </PopoverPanel>
      </Popover>
    </PopoverGroup>
  </div>
</template>

<script>
import { useGroupStore } from "@/stores/groups";
import { useAgentStore } from "@/stores/agents";

import { ChevronDownIcon } from '@heroicons/vue/solid';
import {
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from '@headlessui/vue';


export default {
  name: 'DisplayStatus',
  props: ['displayStatusFilter', 'selectedGroupsCount', 'initialSelectedGroups'],
  emits: ['selected-groups-changed', 'selected-agents-changed', 'selected-filter-by'],
  components: {
    //
    ChevronDownIcon,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
  },
  setup() {
    let groupStore = useGroupStore();
    let agentStore = useAgentStore();
    return { groupStore, agentStore };
  },
  created() {
    this.selectedGroups = this.initialSelectedGroups;
    this.selectedAgents = this.allAgents;
  },
  methods: {
    toggleAllGroups() {
      if (this.allGroupsSelected) {
        this.selectedGroups = [null];
      } else {
        let ids = [null];
        this.groupStore.collection.forEach(g => {
          ids.push(g.id);
        })
        this.selectedGroups = ids;
      }
    },
    toggleAllAgents() {
      if (this.allAgentsSelected) {
        this.selectedAgents = [null];
      } else {
        let ids = [null];
        this.agentStore.collection.forEach(a => {
          ids.push(a.id);
        })
        this.selectedAgents = ids;
      }
    }
  },
  watch: {
    initialSelectedGroups(newSet) {
      if (newSet && newSet !== this.selectedGroups) {
        this.selectedGroups = newSet;
      }
    },
    selectedGroups(newSet) {
      if (newSet) {
        this.$emit('selected-groups-changed', this.selectedGroups);
      }
    },
    selectedAgents(newSet) {
      if (newSet) {
        this.$emit('selected-agents-changed', this.selectedAgents);
      }
    },
    filterBy(newFilter) {
      if (newFilter) {
        this.$emit('selected-filter-by', newFilter);
      }
    },
  },
  computed: {
    allAgentsSelected() {
      return this.selectedAgents.length > this.agentStore.collection.length;
    },
    allGroupsSelected() {
      return this.selectedGroups.length > this.groupStore.collection.length;
    },
    displayStatusFilterAsText() {
      return this.$t(`conversation.${this.displayStatusFilter}`);
    },
    allAgents() {
      let agents = [null];
      this.agentStore.collection.forEach(a => {
        agents.push(a.id);
      });
      return agents;
    },
    selectedAgentsCount() {
      return this.selectedAgents.length;
    }
  },
  data() {
    return {
      selectedGroups: [],
      selectedAgents: [],
      filterBy: 'groups'
    }
  },
}
</script>
